// extracted by mini-css-extract-plugin
module.exports = {"card":"_3oeEV7_W","fallbackContainer":"fxUEAbIq","image":"ApPOWFqs","cardTitle":"HaiO6qA_","details":"_2BHWYLzq","advisorName":"_1kf_aJbF","quote":"_2181RP1U"};